import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 8.6L16.17 10.43L15.09 9.35L15.84 8.6L15.39 8.15L14.64 8.9L13.56 7.82L15.38 6L17.98 8.6H18ZM7.97 16.48H7.52V16.03L13.59 9.96L12.51 8.88L6 15.4V18H8.6L15.11 11.49L14.03 10.41L7.97 16.48Z" fill={ fill || 'currentColor' } />
    </svg>
);